import { Button } from 'app/components/common/Button';
import { DropdownButton } from 'app/components/common/Dropdown';
import { useStore } from 'app/context';
import { FittnessPdfVM } from 'app/stores/ui/agt.fitnesspdf.ui.store';
import { formatBmToQuarter } from 'app/utils';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

interface IFitnessTrackerPdfDownloadButton {
	agtId: number;
	modifier?: string;
}

export const FitnessTrackerPdfDownloadButton = observer((props: IFitnessTrackerPdfDownloadButton) => {
	const { documentUiStore, uiStore, session, agtFitnesspdfUiStore } = useStore();

	const [vm, setVm] = useState<FittnessPdfVM | undefined>(undefined);

	const onClick = async (b: any) => {
		try {
			const blob = await documentUiStore.bnrUploadStore.downloadFitnessPdf(props.agtId, 't', b, true);
			const url = URL.createObjectURL(blob!);
			uiStore.setShowPdf(url);
			return;
		} catch (ex) {
			alert('PDF wurde nicht gefunden.');
			session.decApiCallCount();
		}
	};

	useEffect(() => {
		agtFitnesspdfUiStore.load().then(() => {
			const m = agtFitnesspdfUiStore.getByAgtId(props.agtId);
			setVm(m);
		});
	}, [agtFitnesspdfUiStore.items, props.agtId]);

	const mapDropdownItems = (vm: FittnessPdfVM) => {
		return vm.trackerBms.map((b) => {
			return {
				text: `Fitness Tracker PDF ${formatBmToQuarter(b)}`,
				onClick: () => onClick(b),
			};
		});
	};

	return <>{vm && vm.hasTracker && <DropdownButton className={`is-primary is-small is-inverted is-block`} modifier="fake-button" text="Fitness Tracker PDF" items={mapDropdownItems(vm)} />}</>;
});

export const FitnessTrackerLeitfadenButton = () => {
	return (
		<a
			className={`button is-inverted is-small`}
			href={`https://amisonline.allianz.de/agentur-und-vertrieb/organisation-und-finanzen/steuerung/agentur-der-zukunft/was-ist-adz.html#kpi`}
			title={'Leitfaden'}
			target="_blank"
			rel="noreferrer"
		>
			Leitfaden
		</a>
	);
};
